module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-atendimento",
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-headphones m-r"
  }), _vm._v(" Iniciar Atendimento\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67f05aee","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/callcenter/components/BtnAtendimento.vue
// module id = 1921
// module chunks = 18